import React, { useRef } from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import { Link, useHistory } from "react-router-dom";
import "./index.scss";
import AuthService from "../../../../services/authService";
import AnttButton from "../../../Button";
import { faBars, faUser } from "@fortawesome/free-solid-svg-icons";
import If from "../../../If";
import Environment from "../../../../../environments/environment";

interface Props {
  onClick: () => void;
}

const Topbar: React.FC<Props & { internalAccess: boolean }> = ({
  onClick,
  internalAccess,
}) => {
  const op: any = useRef(null);
  const parent: any = useRef();
  const authService = new AuthService();
  const auth: any = authService.getCurrentState();
  const history = useHistory();

  return (
    <>
      <header ref={parent} style={{ marginTop: "33px" }} className="topbar">
        <div className="topbar-wrapper">
          <div className="topbar-menu-button">
            {!internalAccess && (
              <AnttButton
                faIcon={faBars}
                faIconOpts={{ color: "white", size: "2x" }}
                onClick={() => onClick()}
                type="button"
                data-testid="botao-menu"
                className="topbar-menu-button"
              />
            )}
          </div>
          <Link style={{ paddingTop: "8px" }} to="/home">
            <div className="topbar-logo">
              <div>
                <img
                  data-testid="logo-antt"
                  src="/images/logo2.png"
                  style={{ width: "160px" }}
                />
              </div>
              <div className="topbar-title">
                {/* <h3 data-testid="titulo">{Environment.getNomeSistema()}</h3> */}
                {/* <h6 data-testid="versao">{Environment.getVersaoSistema()}</h6> */}
              </div>
            </div>
          </Link>
        </div>
        <div className="topbar-actions">
          <If condition={auth.user}>
            <AnttButton
              faIcon={faUser}
              faIconOpts={{ color: "white", size: "2x" }}
              className="topbar-menu-button mr-5"
              type="button"
              onClick={(e: any) => {
                if (op != null) {
                  op.current.toggle(e);
                }
              }}
            />
          </If>
        </div>
      </header>
      <OverlayPanel ref={op}>
        <div className="topbar-user-info">
          {auth && auth.user && auth.user.nome && (
            <>
              <h3>
                <b>Nome: </b>
                {auth.user.nome}
              </h3>
              <If condition={!!auth.user.perfil}>
                <h3>
                  <b>Perfil: </b>
                  {auth.user.perfil.join(",")}
                </h3>
              </If>
            </>
          )}
          <h3
            className="topbar-exit"
            onClick={() => {
              authService.logout();
            }}
          >
            Sair
          </h3>
        </div>
      </OverlayPanel>
    </>
  );
};

export default Topbar;
